import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IPrescriptionEventTypeModel extends IModel {
  prescriptionEventTypeId: number;
  name: string;
}

export class PrescriptionEventTypeModel
  extends Model
  implements ModelRecord<IPrescriptionEventTypeModel>
{
  prescriptionEventTypeId: number;
  name: string;
  constructor(params?: Partial<IPrescriptionEventTypeModel>) {
    super(params);
    this.prescriptionEventTypeId = defaultTo(
      params?.prescriptionEventTypeId,
      0,
    );
    this.name = defaultTo(params?.name, '');
  }
}
